// extracted by mini-css-extract-plugin
export default {"dateInput":"dateInput_dateInput__Gpm4T"};